export * from './ui/dialog'
export { default as DialogWrapper } from './ui/dialog-wrapper'
export type { ComponentProps as DialogWrapperProps } from './ui/dialog-wrapper'
